import { Modal } from 'antd';
import { useI18n } from '../../shared/i18n';

interface ModalProps {
  open: boolean;
  close:
    | (React.MouseEventHandler<HTMLAnchorElement> &
        React.MouseEventHandler<HTMLButtonElement>)
    | undefined;
  title: React.ReactNode;
  children: React.ReactNode;
  confirmLoading?: boolean;
  closable?: boolean;
  maskClosable?: boolean;
  onOk?:
    | (React.MouseEventHandler<HTMLAnchorElement> &
        React.MouseEventHandler<HTMLButtonElement>)
    | undefined;
  okText?: string | null;
  cancelText?: string | null;
  style?: React.CSSProperties | undefined;
  width?: number;
  footer?: React.ReactNode | null;
  okButtonProps?: any;
  cancelButtonProps?: any;
}

export const AModal: React.FC<ModalProps> = ({
  open,
  close,
  title,
  onOk,
  confirmLoading,
  okText,
  cancelText,
  style,
  children,
  width,
  footer,
  closable,
  maskClosable,
  okButtonProps,
  cancelButtonProps,
}) => {
  const { t } = useI18n();

  return (
    <>
      <Modal
        title={title}
        centered
        confirmLoading={confirmLoading}
        open={open}
        onOk={onOk}
        okText={okText ?? t('modal.ok')}
        cancelText={cancelText ?? t('modal.cancel')}
        onCancel={close}
        style={style}
        width={width}
        footer={footer}
        closable={closable ?? true}
        maskClosable={maskClosable ?? true}
        okButtonProps={okButtonProps}
        cancelButtonProps={cancelButtonProps}
      >
        {children}
      </Modal>
    </>
  );
};
